// src/poker/table/HandResultPanel.js
import React from "react";

function fmtSigned(n) {
  const x = Number(n || 0);
  if (!x) return null;
  const sign = x > 0 ? "+" : "−";
  return `${sign}${Math.abs(x)}`;
}

function resultLabel(n) {
  const x = Number(n || 0);
  if (!x) return null;
  return x > 0 ? "ZYSK" : "STRATA";
}

function getSeatLabel(seatNoStr, seats) {
  const seatNo = Number(seatNoStr);
  const meta = Array.isArray(seats) ? seats.find((s) => Number(s.seat) === seatNo) : null;
  const name =
    meta?.name || meta?.nick || meta?.username || meta?.login || meta?.email || `Seat ${seatNo}`;
  return `${name} (${seatNo})`;
}

export default function HandResultPanel({
  show,
  winners = [],
  winnersSet,
  bySeat,
  payouts,

  // optional (recommended):
  seats,
  seatState,
}) {
  if (!show) return null;

  const bySeatKeys = Object.keys(bySeat || {});
  const payoutKeys = Object.keys(payouts || {});
  const seatKeys = Array.from(new Set([...bySeatKeys, ...payoutKeys])).sort((a, b) => Number(a) - Number(b));

  const hasShowdownHands = bySeatKeys.length > 0;
  const endedByFold = !hasShowdownHands && winners.length > 0;

  return (
    <div className="poker-card" style={{ marginTop: 12 }}>
      <div style={{ fontWeight: 900, marginBottom: 6 }}>Wynik rozdania</div>

      {winners.length ? (
        <div style={{ opacity: 0.9, fontSize: 13 }}>
          {winners.length === 1 ? (
            <>
              Zwycięzca: <b>{getSeatLabel(String(winners[0]), seats)}</b>
            </>
          ) : (
            <>
              Remis: <b>{winners.map((s) => getSeatLabel(String(s), seats)).join(", ")}</b>
            </>
          )}
        </div>
      ) : (
        <div style={{ opacity: 0.9, fontSize: 13 }}>Brak informacji o zwycięzcy.</div>
      )}

      {endedByFold ? (
        <div style={{ marginTop: 6, opacity: 0.75, fontSize: 12 }}>
          (Rozdanie zakończone foldem — brak porównania układów.)
        </div>
      ) : null}

      <div style={{ marginTop: 10, display: "grid", gap: 6 }}>
        {seatKeys.length ? (
          seatKeys.map((seatNoStr) => {
            const seatNo = Number(seatNoStr);
            const h = bySeat?.[seatNoStr] || null;

            const win = winnersSet?.has?.(seatNo) || false;

            const delta = Number(payouts?.[seatNoStr] || 0);
            const deltaTxt = fmtSigned(delta);
            const lab = resultLabel(delta);

            const foldedState = !!seatState?.[seatNoStr]?.folded;
            const folded = foldedState || (endedByFold && !win);

            const descr = hasShowdownHands ? (h?.descr || h?.name || "-") : "—";

            return (
              <div key={seatNoStr} style={{ fontSize: 13, opacity: 0.95 }}>
                <b>{getSeatLabel(seatNoStr, seats)}</b>: {descr}

                {folded ? (
                  <span style={{ marginLeft: 10, fontWeight: 900, color: "rgba(255,80,80,0.95)" }}>
                    FOLD
                  </span>
                ) : null}

                {win ? (
                  <span style={{ marginLeft: 10, fontWeight: 900 }}>
                    ✅ {winners.length > 1 ? "REMIS" : "WYGRANA"}
                  </span>
                ) : null}

                {deltaTxt ? (
                  <span style={{ marginLeft: 10, fontWeight: 900 }}>
                    {lab ? `${lab} ` : ""}
                    {deltaTxt}
                  </span>
                ) : null}
              </div>
            );
          })
        ) : (
          <div style={{ opacity: 0.8, fontSize: 13 }}>(Brak danych `handResult.payouts`.)</div>
        )}
      </div>
    </div>
  );
}
